import React, {useEffect, useState, useRef} from "react";
import {useInterval} from "./utils";
import {motion} from "framer-motion";
import "./Header.css";

let Header = (props) => {
    let [isShrinked, shrinked] = useState(false);
    let [height, setHeight] = useState(0);
    let active = true;

    useEffect(()=>{
        window.scrollTo(0,-1000)
    }, [props.children])

    useEffect(()=>{
        setHeight(document.getElementById('header').clientHeight);
    },[props.children]);

    useInterval(()=>{
        if (document.getElementById('View--panel').scrollTop > document.getElementById('header').clientHeight/2) {
            shrinked(true);
        } else {
            shrinked(false);
        }
    },10);

    return(
        <div id="header" className="Header">
            <motion.div id="header" className={isShrinked ? "Header--expanded" : "Header--shrinked"}>
                {props.before ? <div className="Header--before">
                    {props.before}
                </div> : ""}
                <div>
                    {!isShrinked && props.status ? <div className="Header--status">{props.status}</div> : false}
                    <div className="Header--content">
                        <div className={isShrinked ? "Header--title": ""}>{props.children}</div>
                    </div>
                </div>
                {!isShrinked && props.after ? <div className="Header--after">
                    {props.after}
                </div>:""}
            </motion.div>
            <div id="header--placeholder" style={{height: height}}/>
        </div>
    );
}

export default Header;